import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import Messages from './Messages';
import s from './HistoryEvents.css';

class HistoryHeaderRow extends React.Component {
  render() {
    const { event, index } = this.props;
    const messages = Messages();
    let value = event.get(1);
    const isSpaced = value.split(' ').length > 1;
    value = isSpaced ? value.split(' ')[1] : value;
    return (
      <tr key={index} className={cx(s.row_container, s.header_color)}>
        <td>
          <FormattedMessage {...messages[value]} />
        </td>
      </tr>
    );
  }
}

HistoryHeaderRow.propTypes = {
  index: PropTypes.number.isRequired,
  event: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withStyles(s)(HistoryHeaderRow);



// WEBPACK FOOTER //
// ./src/components/HistoryEvents/HistoryHeaderRow.js